import React, { FC, FormEventHandler, useEffect, useState } from 'react';
import Checkbox from 'components/commercetools-ui/atoms/checkbox';
import IconPlus from 'components/icons/plus';
import IconMinus from 'components/icons/minus';
import Typography from 'components/commercetools-ui/atoms/typography';
import Button from 'components/commercetools-ui/atoms/button';
import { ShoppingList } from '../types';
interface IProps {
  project: ShoppingList;
  selectedProjects: any;
  handleIncrement: (shoppingListId: string, roomLabel: any, existingItem?:any) => void;
  handleRoomSelection: (project: ShoppingList, roomLabel: any, existingItem?:any) => void;
  handleDecrement: (shoppingListId: string, roomLabel: string, existingItem?:any) => void;
  handleAddNote: (src: any) => void;
  productToAdd:any
}

const Rooms: React.FC<IProps> = ({
  project,
  selectedProjects,
  handleIncrement,
  handleDecrement,
  handleRoomSelection,
  handleAddNote,
  productToAdd,
}) => {
  // const [showMore, setShowMore] = useState<boolean>(false);
 
  const getChecked = (project: ShoppingList, roomLabel: any, existingItem?: any) => {
    return (
      // Case 1: A new room is added
      selectedProjects.some(
        (selectedProject: any) =>
          selectedProject.shoppingListId === project.shoppingListId &&
          selectedProject.selectedRooms.some(
            (r: any) => r.roomLabel === roomLabel && !r.lineItemId
          )
      ) ||
      // Case 2: Existing item is already selected with roomNotes or quantity
      (!!existingItem?.id &&
        selectedProjects.some(
          (selectedProject: any) =>
            selectedProject.shoppingListId === project.shoppingListId &&
            selectedProject.selectedRooms.some(
              (r: any) =>
                r.roomLabel === roomLabel &&
                r.lineItemId === existingItem.id &&
                (!!r.quantity || !!r.roomNotes)
            )
        )) ||
      // Case 3: No selected item but existing item exists
      (!!existingItem?.id && !selectedProjects.some(
        (selectedProject: any) =>
          selectedProject.shoppingListId === project.shoppingListId &&
          selectedProject.selectedRooms.some(
            (r: any) => r.roomLabel === roomLabel && r.lineItemId === existingItem.id
          )
      ))
    );
  };
  
  
  
  const getRoomQuantity = (roomLabel: string, shoppingListId?: string, existingItem?: any): number => {
    const project = shoppingListId
      ? selectedProjects.find((proj: any) => proj.shoppingListId === shoppingListId)
      : selectedProjects.find((proj: any) => proj.selectedRooms.some((r: any) => r.roomLabel === roomLabel));
  
    if (!project && !existingItem?.id) return 0;
  
    const room = project?.selectedRooms.find((r: any) => r.roomLabel === roomLabel);
    if (room && !room.quantity) return 0;
  
    return room?.quantity ?? existingItem?.quantity ?? 0;
  };
  
  const getRoomNotes = (shoppingListId: string, roomLabel: string, existingItem?: any): string => {
    const project = selectedProjects.find((project: any) => project.shoppingListId === shoppingListId);
  
    if (!project) return existingItem?.roomNotes ?? '';
  
    const room = project.selectedRooms.find((room: any) => room.roomLabel === roomLabel);
  
    // Return roomNotes from the room or fallback to existingItem
    return room?.roomNotes ?? existingItem?.roomNotes ?? '';
  };
  
  
  return (
    <div>
      <div className="flex flex-col gap-12 px-12">
        {project?.roomLabels?.map((roomLabel: any,idx:any) => {
          return (
            <div key={idx}>
              <Room
                roomLabel={roomLabel}
                project={project}
                getChecked={getChecked}
                handleRoomSelection={handleRoomSelection}
                handleDecrement={handleDecrement}
                handleIncrement={handleIncrement}
                getRoomQuantity={getRoomQuantity}
                handleAddNote={handleAddNote}
                getRoomNotes={getRoomNotes}
                productToAdd={productToAdd}
              />
            </div>
          );
        })}
      </div>
      {/* {rooms.length > 6 && (
        <div className='px-8 md:!pb-22'>
          <button
            onClick={() => setShowMore(!showMore)}
            className="text-14 text-[#666] hover:text-[#090909] hover:!cursor-pointer underline"
          >
            {showMore ? 'Show Less' : 'Show More'}
          </button>
        </div>
      )} */}
    </div>
  );
};

export default Rooms;

const Room: FC<any> = ({
  roomLabel,
  project,
  getChecked,
  handleRoomSelection,
  handleDecrement,
  handleIncrement,
  getRoomQuantity,
  getRoomNotes,
  handleAddNote,
  productToAdd,
}) => {
  const [addNote, setAddNote] = useState<boolean>(false);
  const [note, setNote] = useState<string>('');
  const existingItem = project.lineItems.find(
    (item: any) => item.name === productToAdd.name && item.roomName === roomLabel,
  );

  useEffect(() => {
    setNote(getRoomNotes(project.shoppingListId, roomLabel, existingItem));
  }, [addNote]);

  return (
    <div key={roomLabel}>
      <div className="flex items-center justify-between">
        <label 
         className="flex items-center justify-start gap-12">
          <Checkbox
            id={roomLabel}
            checked={!!getChecked(project, roomLabel, existingItem)}
            className="hover:cursor-pointer"
            buttonClassNameOverride="outline-2 outline-[#CCCCCC]"
            labelPosition="on-left"
            onClick={(e) => {
              e.stopPropagation();
              handleRoomSelection({
                project,
                roomLabel,
                ...(existingItem?{existingItem} : {}),
              });
            }}
          />
          <span
            className="w-fit text-16 font-normal text-[#090909] md:text-14  2xl:text-16"
          >
            <Typography as='span' className="w-fit  text-16 hover:cursor-pointer">
              {roomLabel}
            </Typography>
          </span>
          <div className="flex items-center gap-12"></div>
        </label>
        {!!getChecked(project, roomLabel, existingItem) && (
          <div className="flex items-center gap-10 select-none">
            <IconMinus className="cursor-pointer" onClick={() => handleDecrement(project.shoppingListId, roomLabel, existingItem)} />
            <span className="text-14 text-[#090909]">{getRoomQuantity(roomLabel, project.shoppingListId, existingItem)}</span>
            <IconPlus className="cursor-pointer" onClick={() => handleIncrement(project.shoppingListId, roomLabel, existingItem)} />
          </div>
        )}
      </div>
      {!!getChecked(project, roomLabel, existingItem) && !addNote && (
        <button type="button" className="padding-l-32 pt-12 select-none	" onClick={() => setAddNote(true)}>
          <Typography className="cursor-pointer text-[#090909] underline  ">Add a note</Typography>
        </button>
      )}
      {addNote && !!getChecked(project, roomLabel, existingItem) && (
        <div className="padding-l-32 pt-12">
          <textarea
            name="note"
            value={note}
            onChange={(e) => {
              setNote(e.target.value);
            }}
            placeholder="Note"
            maxLength={300}
            autoComplete=""
            rows={5}
            className="w-full rounded border border-[#DDDDDD]  focus:border-gray-600 focus:ring-0 focus:outline-none  px-13 py-6 text-left !text-14 text-black placeholder:text-[#666666]"
          />
          <div className="flex items-center padding-b-24 gap-32 pt-12">
            <Button
              disabled={!existingItem?.roomNotes && !note}
              onClick={() => {
                handleAddNote({shoppingListId:project.shoppingListId, roomLabel, note, existingItem});
                setAddNote(false);
              }}
              className={
                ' border-1 z-10 w-full rounded-none border !border-[#2B2C39] bg-[#2B2C39] px-13 py-9 shadow-sm hover:!bg-[#394A54] disabled:!border-neutral-400 hover:disabled:!bg-neutral-400 md:w-fit'
              }
            >
              <Typography as="span" className={`text-14 font-medium text-[#fff]`}>
                Add note
              </Typography>
            </Button>
            <Button
              onClick={() => {
                setAddNote(false);
                setNote('');
              }}
              className={
                'border-1 z-10 w-full rounded-none border !border-[#2B2C39] bg-white px-13 py-9 shadow-sm hover:!border-[#F4F4F4] hover:!bg-[#F4F4F4] md:w-fit'
              }
            >
              <Typography as="span" className={`text-14 font-medium text-[#090909]`}>
                Cancel
              </Typography>
            </Button>
          </div>
        </div>
      )}
    </div>
  );
};
